import script from "./SaleReturns.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleReturns.vue?vue&type=script&setup=true&lang=js"

import "./SaleReturns.vue?vue&type=style&index=0&id=6a7121f1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a7121f1"]])

export default __exports__